import axios from '../../axios/index.js'

export default {
  addTaxReturn(data) {
    return axios.post('taxes/addTaxReturn', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
      processData: false,
      contentType: false
    })
  },
  updateTaxReturn(data) {
    return axios.post('taxes/updateTaxReturn', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
      processData: false,
      contentType: false
    })
  },
  IvaReturnList(data) {
    return axios.post('/expenses/iva_return',data)
  },
  approve(data) {
    return axios.post('taxes/approve', data)
  }
}
